import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSavings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.72144 13.8752C6.47226 13.8752 4.52369 13.0887 3.7273 11.9969M8.72144 17.6199C6.4766 17.6199 4.61819 16.9063 3.82577 15.8235C3.74033 15.7068 3.70369 15.5632 3.70383 15.4185L3.7117 7.20507M14.4287 7.23976C14.4287 8.88665 12.0278 10.2217 9.06616 10.2217C6.10451 10.2217 3.70361 8.88665 3.70361 7.23976C3.70361 5.59288 6.10451 4.25781 9.06616 4.25781C12.0278 4.25781 14.4287 5.59288 14.4287 7.23976Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.7549 13.8882V17.9913C10.7549 18.1322 10.7915 18.272 10.8768 18.3856C11.6691 19.4419 13.5276 20.1381 15.7727 20.1381C18.0178 20.1381 19.8763 19.4419 20.6686 18.3856C20.7539 18.272 20.7905 18.1322 20.7905 17.9913V13.8882M20.7905 14.1047C20.7905 15.711 18.544 17.0131 15.7727 17.0131C13.0014 17.0131 10.7549 15.711 10.7549 14.1047C10.7549 12.4984 13.0014 11.1963 15.7727 11.1963C18.544 11.1963 20.7905 12.4984 20.7905 14.1047Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	})]
});
export default SvgSavings;
